import * as a0 from '@grins/views/layouts/layout.ts';
let a0_ = "" + void a0;
import * as a1 from '@grins/views/layouts/bonz.tsx';
let a1_ = "" + void a1;
import * as a2 from '@grins/views/bonz/partials/ErrorNotification.tsx';
let a2_ = "" + void a2;
import * as a3 from '@grins/views/shared/partials/FocusableInput.tsx';
let a3_ = "" + void a3;
import * as a4 from '@grins/views/bonz/partials/ValidationTip.tsx';
let a4_ = "" + void a4;
import * as a5 from '@grins/views/bonz/partials/AddFaveTheater.tsx';
let a5_ = "" + void a5;
import * as a6 from '@grins/views/bonz/partials/AddFaveMovie.tsx';
let a6_ = "" + void a6;
import * as a7 from '@grins/views/bonz/partials/PerksList.tsx';
let a7_ = "" + void a7;
import '@grins/views/layouts/partials/bonz/bonzGlobalStyles.client.css';
import '@grins/views/layouts/bonz.client.ts';
import '@grins/views/bonz/joinNow.client.css';
import '@grins/views/bonz/joinNow.client.ts';